// extracted by css-extract-rspack-plugin
export default {"InfoLink":"gleRs","TooltipLabel":"yJLZU"};